import { urlpostfix } from "@/http/global.js";
import { post, getJSON } from "@/http/http.js";

/**
 *
 * @description  列表接口
 *

 * */
export function listData(datas) {
  var url = "./static/datas.json";
  return getJSON(url, datas);
}
/**
 *
 * @description  列表接口
 *

 * */
export function indexlistData() {
  var url = "./static/indexdatas.json";
  return getJSON(url);
}
/**
 *
 * @description  列表接口
 *

 * */
export function listTitles() {
  var url = "./static/titles.json";
  return getJSON(url);
}
/**
 *
 * @description  详情接口
 *
 *
 * */
export function getInfo(datas) {
  var url = `https://${datas.Prefix}${urlpostfix}VoteItem/GetVoteItem?c=view`;
  return post(url, datas);
}

/**
 *
 * @description  重大记事、纪念活动:basic
 *
 * */
export function majoranniInfo(data) {
  return post(`${urlpostfix}api/cemetery/basic/info/${data}`);
}



// WEBPACK FOOTER //
// ./src/api/datas.js